import React from 'react';

function Step3({ trail, date, hour, recipient, paymentType, onPaymentTypeChange, equipments, price }) {
  return (
    <section className="step">
      <div className="mb-4">
          <h5 className="widget-title text-center">Krok 3/3: Podsumowanie</h5>
          <div className="progress" style={{ height: '8px' }}>
              <div className="progress-bar position-relative bg-primary" style={{ width: '99%' }}></div>
          </div>
      </div>

      <h5>Dane:</h5>
      <p>
        <span className="text-muted">Trasa:</span> {trail.title} <br/>
        {/* <span className="text-muted">Czas spływu:</span> ok. {trail.tripTimeMinutes} min<br/> */}
        {/* <span className="text-muted" v-if=trail.description_distance>Długość trasy:</span> {trail.description_distance} <br/> */}
      </p>

      <p>
        <span className="text-muted">Data spływu:</span> {date}<br/>
        <span className="text-muted">Godzina spływu:</span> {hour}<br/>
      </p>
      
      <p>
        <span className="text-muted">Email:</span> {recipient.email} <br/>
        <span className="text-muted">Imię, nazwisko:</span> {recipient.firstName} {recipient.lastName} <br/>
        <span className="text-muted">Tel. kontaktowy:</span> {recipient.phone} <br/>
      </p>
      <hr/>

      <h5>Sprzęt:</h5>
      <div className="table-responsive">
        <table className="table table-center table-padding mb-4">
            <tbody>
                {equipments.map(eq => {
                  const equipmentToTrail = trail.equipmentToTrail.find(x => x.id === eq.equipmentToTrailId);
                  return (
                    <tr key={equipmentToTrail.id}>
                      <td className="h6 border-0">{eq.count} x {equipmentToTrail.equipment.title}</td>
                      <td className="text-end fw-bold border-0">{Math.round(eq.count * equipmentToTrail.price)}zł</td>
                    </tr>
                  )
                })}
                <tr className="bg-light">
                    <td className="h5 fw-bold">Cena łącznie:</td>
                    <td className="text-end text-primary h4 fw-bold">{price}zł</td>
                </tr>
            </tbody>
        </table>
      </div>

      <h5>Sposób płatności {false && <span className="badge bg-danger">(tryb testowy)</span>} <span className="text-danger">*</span></h5>
      <ul className="list-unstyled mt-4 mb-0">
          <li className="mb-2">
              <div className="custom-control custom-radio custom-control-inline">
                  <div className="form-check mb-0">
                      <input 
                        className="form-check-input" 
                        type="radio" 
                        checked={paymentType === 1} 
                        value={1} 
                        onChange={e => onPaymentTypeChange(+e.target.value)} 
                        name="payment-type" 
                        id="payment-type-1"
                      />
                      <label className="form-check-label" htmlFor="payment-type-1">Płatność gotówką</label>
                      <br/>
                      <small>Płatność gotówką na miejscu.</small>
                  </div>
                  {/* <div className="form-check mb-0">
                      <input
                        className="form-check-input"
                        type="radio" 
                        checked={paymentType === 2} 
                        value={2} 
                        onChange={e => onPaymentTypeChange(+e.target.value)} 
                        name="payment-type" 
                        id="payment-type-2"
                      />
                      <label className="form-check-label" htmlFor="payment-type-2">Płatność online</label>
                      <br/>
                      <small>Natychmiastowa płatność online <img src="/img/Przelewy24_logo.svg" alt="Dotpay.pl" style={{ height: '20px', verticalAlign: 'text-bottom' }} /></small>
                  </div> */}
              </div>
          </li>
      </ul>

    </section>
  );
}

export default Step3;
